<template>
  <div class="lnb_wrap">
    <template v-if="smenu == 'info'">
      <h2>경유증표 안내 </h2>
      <ul class="lnb_dep01">
        <s-link tag="dd" to="/info/info_kind">경유증표 종류</s-link>
        <s-link tag="dd" to="/info/info_law">관련 규정</s-link>
        <s-link tag="dd" to="/board/faq">FAQ <small>자주묻는 질문</small></s-link>
      </ul>
    </template>
    <template v-if="smenu == 'board'">
      <h2>공지사항 </h2>
      <ul class="lnb_dep01">
        <s-link tag="dd" to="/board/board_list" :class="{on: path == '/board/board_view'}">공지사항</s-link>
      </ul>
    </template>
    <template v-if="smenu == 'buy'">
      <h2>증표 구입 </h2>
      <ul class="lnb_dep01">
        <s-link tag="dd" to="/buy/buy_form" :class="{on: path == '/buy/buy_ok'}">증표 구입</s-link>
        <s-link tag="dd" to="/buy/buy_list">증표 구입 내역</s-link>
        <s-link tag="dd" to="/buy/buy_receipt_list">기간별 영수증 출력</s-link>
      </ul>
    </template>

    <template v-else-if="smenu == 'use'">
      <h2 class="line2">증표 <BR/><font>사용</font>·조회·수정</h2>
      <ul class="lnb_dep01">
        <s-link tag="dd" to="/use/use_via">증표 사용</s-link>
        <s-link tag="dd" to="/use/edit_via">증표 사용 내역 조회·수정</s-link>
      </ul>
    </template>

    <template v-else-if="smenu == 'apply'">
      <h2>신고·신청</h2>
      <ul class="lnb_dep01">
        <s-link tag="dd" to="/apply/viafree_req" :class="{on: (path == '/apply/viafree_choffice') || (path == '/apply/viafree_bokdari')}">면제증표 신청</s-link>
        <s-link tag="dd" to="/apply/ch_owner">미사용 증표 전환 신청<br>(명의변경)</s-link>
        <s-link tag="dd" to="/apply/refund">미사용 증표 환불 신청</s-link>
        <s-link tag="dd" to="/apply/wrong_change_req">오사용 증표 정정 신청</s-link>
      <!--   <s-link tag="dd" to="/apply/ch_online">오프라인증표 교환 신청</s-link> -->
        <s-link tag="dd" to="/apply/stat_list">신청내역 확인</s-link>
        <s-link tag="dd" to="/apply/return_req_req">수임사건 신고</s-link>
      </ul>
    </template>

    <template v-else-if="smenu == 'report'">
      <h2 class="line2">수임사건 <BR/>내역조회</h2>
      <ul class="lnb_dep01">
        <s-link tag="dd" to="/report/report_viacnt">수임사건 건수 조회</s-link>
        <s-link tag="dd" to="/report/report_viadetail">수임사건 상세 조회</s-link>
        <s-link tag="dd" to="/report/report_viacancel">수임사건 사임/취하 <br>건수 조회</s-link>
      </ul>
    </template>

    <template v-else-if="smenu == 'member'">
      <h2>회원</h2>
      <ul class="lnb_dep01">
        <s-link tag="dd" :to="_config.LOGIN_PATH">로그인</s-link>
        <s-link tag="dd" :to="_config.LOGOUT_PATH">로그아웃</s-link>
        <s-link tag="dd" to="/member/join" :class="{on: path == '/member/join_form'}">회원가입</s-link>

        <s-link tag="dd" to="/member/info/customerpersonal">개인정보보호방침</s-link>
        <s-link tag="dd" to="/member/info/customerclause">홈페이지 이용약관</s-link>
        <s-link tag="dd" to="/member/info/customersite">관련사이트</s-link>
        <s-link tag="dd" to="/member/info/customeremail">이메일주소 무단수집거부</s-link>

      </ul>
    </template>

    <template v-else-if="smenu == 'mypage'">
      <h2>마이페이지</h2>
      <ul class="lnb_dep01">
        <s-link tag="dd" to="/mypage/qna" :class="{on: /\/qna_/.test(path) }" >1:1 질의응답</s-link>
        <s-link tag="dd" to="/mypage/setting_master" v-if="$store.state.session.user.type == 'master'">소속변호사 권한 설정</s-link>
        <s-link tag="dd" to="/mypage/myreqlist">신청내역확인</s-link>
        <dd @click="goRemotPage">원격지원</dd>
        <s-link tag="dd" to="/mypage/change_pw" v-if="this.$store.state.session.user.type == 'master'">비밀번호 변경</s-link>
        <dd @click="goSeoulbarPage" v-if="this.$store.state.session.user.type != 'master'">비밀번호 변경</dd>
      </ul>
    </template>

    <template v-else-if="smenu == 'sample'">
      <h2>SAMPLE</h2>
      <ul class="lnb_dep01">
        <s-link tag="dd" to="/sample/중요변수들">중요변수들</s-link>
        <s-link tag="dd" to="/sample/devMemo">개발메모</s-link>
        <s-link tag="dd" to="/sample/proc_list">LIST</s-link>
        <s-link tag="dd" to="/sample/proc_list_page">LIST(페이징)</s-link>
        <s-link tag="dd" to="/sample/w_list_page">LIST(페이징-W)</s-link>
        <s-link tag="dd" to="/sample/s-table3">s-table3</s-link>
        <s-link tag="dd" to="/sample/confirm_alert">ALERT,CONFIRM,NOTIFY</s-link>
        <s-link tag="dd" to="/sample/fileattach">파일첨부</s-link>
        <s-link tag="dd" to="/sample/fileattach2">파일첨부2</s-link>
        <s-link tag="dd" to="/sample/회원선택">회원선택</s-link>
        <s-link tag="dd" to="/sample/레포트">레포트</s-link>
      </ul>
    </template>

  </div>
</template>

<script>
export default {
  computed: {
    smenu() { return this.$route.meta.smenu },
    path()  { return this.$route.path },
  },
  methods: {
    goRemotPage() {
      if (confirm("원격지원 페이지로 이동하시겠습니까 ?")) {
        window.open("https://939.co.kr/sbar/", '_blank');
      }
    },
    goSeoulbarPage(){ // 마스터 회원이 아닐 경우 비밀번호 변경 -> 본회 홈페이지로
      window.open("https://www.seoulbar.or.kr/site/mypage/MypageProfileView.do", '_blank');
    }
  },
}
</script>